package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Bosnia and Herzegovina Flag (20x15dp)
 *
 * - ISO Alpha-2: BA
 * - ISO Alpha-3: BIH
 * - ISO Numeric: 070
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.BosniaAndHerzegovina: ImageVector by lazy {
    ImageVector.Builder(
        name = "Bosnia and Herzegovina:BA:BIH:070:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(20.25f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.25f, 0f)
                horizontalLineTo(19f)
                verticalLineTo(15f)
                lineTo(6.25f, 0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.443f, 1.746f)
                lineTo(3.708f, 2.132f)
                lineTo(3.848f, 1.314f)
                lineTo(3.254f, 0.735f)
                lineTo(4.075f, 0.615f)
                lineTo(4.443f, -0.129f)
                lineTo(4.81f, 0.615f)
                lineTo(5.631f, 0.735f)
                lineTo(5.037f, 1.314f)
                lineTo(5.177f, 2.132f)
                lineTo(4.443f, 1.746f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.622f, 4.421f)
                lineTo(5.887f, 4.807f)
                lineTo(6.027f, 3.989f)
                lineTo(5.433f, 3.41f)
                lineTo(6.254f, 3.291f)
                lineTo(6.622f, 2.546f)
                lineTo(6.989f, 3.291f)
                lineTo(7.811f, 3.41f)
                lineTo(7.216f, 3.989f)
                lineTo(7.356f, 4.807f)
                lineTo(6.622f, 4.421f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.665f, 7.024f)
                lineTo(7.93f, 7.41f)
                lineTo(8.07f, 6.592f)
                lineTo(7.476f, 6.013f)
                lineTo(8.297f, 5.893f)
                lineTo(8.665f, 5.149f)
                lineTo(9.032f, 5.893f)
                lineTo(9.853f, 6.013f)
                lineTo(9.259f, 6.592f)
                lineTo(9.399f, 7.41f)
                lineTo(8.665f, 7.024f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.666f, 9.518f)
                lineTo(9.931f, 9.905f)
                lineTo(10.071f, 9.086f)
                lineTo(9.477f, 8.507f)
                lineTo(10.299f, 8.388f)
                lineTo(10.666f, 7.643f)
                lineTo(11.033f, 8.388f)
                lineTo(11.855f, 8.507f)
                lineTo(11.26f, 9.086f)
                lineTo(11.401f, 9.905f)
                lineTo(10.666f, 9.518f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.821f, 12.085f)
                lineTo(12.087f, 12.472f)
                lineTo(12.227f, 11.654f)
                lineTo(11.633f, 11.074f)
                lineTo(12.454f, 10.955f)
                lineTo(12.821f, 10.21f)
                lineTo(13.189f, 10.955f)
                lineTo(14.01f, 11.074f)
                lineTo(13.416f, 11.654f)
                lineTo(13.556f, 12.472f)
                lineTo(12.821f, 12.085f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.204f, 14.569f)
                lineTo(14.469f, 14.956f)
                lineTo(14.61f, 14.137f)
                lineTo(14.016f, 13.558f)
                lineTo(14.837f, 13.439f)
                lineTo(15.204f, 12.694f)
                lineTo(15.572f, 13.439f)
                lineTo(16.393f, 13.558f)
                lineTo(15.799f, 14.137f)
                lineTo(15.939f, 14.956f)
                lineTo(15.204f, 14.569f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun BosniaAndHerzegovinaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.BosniaAndHerzegovina,
            contentDescription = "Bosnia and Herzegovina Flag"
        )
    }
}
